import * as React from 'react';
import { View } from 'react-native';
import Amount from 'design-system/Amount';
import Separator from 'design-system/Separator';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
const PotListSectionHeader = ({ title, totalBalance, interestRate }) => {
    const styles = useStyles(styleSet);
    return (<View style={styles.container}>
      <View style={styles.title}>
        <View style={styles.titleContainer}>
          <View style={styles.flex}>
            <Text Text-16>{title}</Text>
            {!!interestRate && (<Text TextThin-14 Secondary>
                <Text NumbersThin-14 Secondary>
                  {interestRate}%
                </Text>{' '}
                AER
              </Text>)}
          </View>
          <Amount Numbers-16 value={{ value: totalBalance, currency: 'GBP' }}/>
        </View>
      </View>
      <Separator />
    </View>);
};
export default PotListSectionHeader;
const styleSet = createStyleSheets((colors) => ({
    container: {
        marginTop: rem(16),
        marginHorizontal: rem(16),
    },
    title: {
        padding: rem(16),
        flexDirection: 'row',
        borderTopLeftRadius: rem(16),
        borderTopRightRadius: rem(16),
        backgroundColor: colors.cards.onDark,
    },
    titleContainer: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
    },
    flex: {
        flex: 1,
    },
}));
